import type { Column, Filter } from '@/components/table/base'
import type { LicensePropertyOperatorData } from '@/stores/licenseProperty'

export const LICENSE_PROPERTY_TABLE_COLUMNS: Column<LicensePropertyOperatorData>[] = [
  {
    type: 'text',
    id: 'name',
    label: 'Operator',
    sortAttribute: 'name'
  },
  {
    type: 'number',
    id: 'id',
    label: 'Operator ID',
    sortAttribute: 'id'
  },
  {
    type: 'text',
    id: 'email',
    label: 'Contact',
    sortAttribute: 'email'
  },
  {
    type: 'number',
    id: 'usersCount',
    label: 'Number of Users',
    sortAttribute: 'usersCount'
  }
]

export const LICENSE_PROPERTY_TABLE_FILTERS = (
  data: LicensePropertyOperatorData[]
): Filter<LicensePropertyOperatorData>[] => [
  {
    type: 'freeTextSearch',
    paramName: 'ft',
    placeholder: 'Search Operator / ID',
    filterOptions: (row, search) => {
      if (!search) return true

      const lowerCaseSearch = search.toLowerCase()
      const { name, id } = row
      const lowerCaseName = name.toLowerCase()

      return lowerCaseName.includes(lowerCaseSearch) || id.toString().includes(lowerCaseSearch)
    }
  },
  {
    type: 'select',
    label: 'Year',
    paramName: 'year',
    multiple: true,
    options: Array.from(
      new Set(
        data.flatMap((operator) =>
          operator.license.flatMap((license) =>
            license.licensingPeriods.map((period) => new Date(period.endDate).getFullYear())
          )
        )
      )
    )
      .sort((a, b) => (a > b ? 1 : -1))
      .map((year) => ({ value: year, label: year.toString() })),
    filterOptions: (row, selectedOptions) => {
      if (selectedOptions.length === 0) return true
      const selectedYears = selectedOptions.map((option) => option.value)
      const operatorYears = row.license.flatMap((license) =>
        license.licensingPeriods.map((period) => new Date(period.endDate).getFullYear())
      )
      return operatorYears.some((year) => selectedYears.includes(year))
    },
    width: 150
  }
]

export const CSV_HEADERS = ['Id', 'Name', 'Email', 'Number of Users']

export const formatCsvRow = (row: LicensePropertyOperatorData): string[] => {
  return [row.id.toString(), row.name || '', row.email || '', row.usersCount?.toString() || '0']
}
